export default __webpack_public_path__ + "static/kab-logo-be01162b5b72d3d041cf389fe0549939.svg";